import api from '@/api/marketplacePaymentRules';

const state = {
  all: [],
};

const getters = {
  rules: (state) => state.all,
};

const actions = {
  async getRules({ commit }) {
    const result = await api.getAll();
    commit('setRules', result.data);
    return result.data;
  },
  async createRule({ commit }, rule) {
    const result = await api.post(rule);
    commit('addRule', result.data);
    return result.data;
  },
  async updateRule({ commit }, rule) {
    const result = await api.put(rule);
    commit('updateRule', result.data);
    return result.data;
  },
  async deleteRule({ commit }, id) {
    await api.delete(id);
    commit('removeRule', id);
  },
};

const mutations = {
  setRules(state, rules) {
    state.all = rules;
  },
  addRule(state, rule) {
    state.all.push(rule);
  },
  updateRule(state, rule) {
    const index = state.all.findIndex((r) => r.id === rule.id);
    if (index !== -1) state.all.splice(index, 1, rule);
  },
  removeRule(state, id) {
    const index = state.all.findIndex((r) => r.id === id);
    if (index !== -1) state.all.splice(index, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
